/* Packages */
import React from 'react';
import { render } from 'react-dom';

/* Components */
import ProductOverview from './components/ProductOverview';

/* utilities */
import { parseDataToProps } from '~/utilities';

const productOverviewNodes = Array.from(document.querySelectorAll('.product-overview'));
[...productOverviewNodes].forEach((node) => render(<ProductOverview {...parseDataToProps(node.dataset)} />, node));
